import React, { useEffect, useMemo, useState } from "react";
import { Col, Row, Card, CardBody, Badge, Button, Spinner, Alert } from "reactstrap";
import TableContainer from "../../../components/Common/TableContainer";
import Breadcrumbs from "../../../components/Common/Breadcrumb";
import { fetchUserNames, fetchMagazaNames } from "../../../helpers/lookupNames";

const BASE_URL = "https://harmanappapi.stechomeyazilim.info";

const fmtDate = (v) => (v ? new Date(v).toLocaleString("tr-TR") : "—");

const MagazaFavorileri = () => {
  document.title = "Mağaza Favorileri | HarmanaGEL";

  const authUser = JSON.parse(localStorage.getItem("authUser") || "{}");
  const token = localStorage.getItem("token") || authUser?.Token;
  const headers = { "Content-Type": "application/json", Authorization: `Bearer ${token}` };

  const [liste, setListe] = useState([]);
  const [magazaMap, setMagazaMap] = useState({});
  const [userMap, setUserMap] = useState({});
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState(null);
  const [successMsg, setSuccessMsg] = useState("");

  const fetchListe = async () => {
    setIsLoading(true);
    setError(null);
    try {
      const res = await fetch(`${BASE_URL}/MAGAZA_FAVORILERI?$orderby=ID desc&$top=1000`, { headers });
      const result = await res.json();
      const rows = result.value || [];
      setListe(rows);
      const [mMap, uMap] = await Promise.all([
        fetchMagazaNames(rows.map((r) => r.MAGAZA_ID)),
        fetchUserNames(rows.map((r) => r.KULLANICI_ID)),
      ]);
      setMagazaMap(mMap);
      setUserMap(uMap);
    } catch {
      setError("Mağaza favorileri yüklenirken hata oluştu.");
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => { fetchListe(); }, []);

  const handleDelete = async (id) => {
    if (!window.confirm("Bu favori kaydını silmek istediğinize emin misiniz?")) return;
    try {
      await fetch(`${BASE_URL}/MAGAZA_FAVORILERI(${id})`, { method: "DELETE", headers });
      setSuccessMsg("Favori kaydı silindi.");
      fetchListe();
      setTimeout(() => setSuccessMsg(""), 3000);
    } catch {
      setError("Silme sırasında hata oluştu.");
    }
  };

  const columns = useMemo(() => [
    { header: "#", accessorKey: "ID", enableSorting: true, cell: (c) => <strong>#{c.getValue()}</strong> },
    {
      header: "Mağaza", accessorKey: "MAGAZA_ID", enableSorting: true,
      cell: (c) => <Badge color="light" className="text-dark">{magazaMap[c.getValue()] || `Mağaza #${c.getValue()}`}</Badge>,
    },
    {
      header: "Favoriye Ekleyen", accessorKey: "KULLANICI_ID", enableSorting: true,
      cell: (c) => <span className="fw-medium">{userMap[c.getValue()] || `Kullanıcı #${c.getValue()}`}</span>,
    },
    {
      header: "Favori Tarihi", accessorKey: "FAVORI_TARIHI", enableSorting: true,
      cell: (c) => <small className="text-muted">{fmtDate(c.getValue())}</small>,
    },
    {
      header: "İşlemler", enableSorting: false,
      cell: (cellProps) => (
        <Button color="danger" size="sm" outline onClick={() => handleDelete(cellProps.row.original.ID)}>
          <i className="bx bx-trash" />
        </Button>
      ),
    },
  ], [magazaMap, userMap]); // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <React.Fragment>
      <div className="page-content">
        <div className="container-fluid">
          <Breadcrumbs title="İlan Yönetimi" breadcrumbItem="Mağaza Favorileri" />
          {successMsg && <Alert color="success">{successMsg}</Alert>}
          {error && <Alert color="danger" toggle={() => setError(null)}>{error}</Alert>}
          <Row>
            <Col lg={12}>
              <Card>
                <CardBody>
                  <div className="mb-3 d-flex justify-content-between align-items-center">
                    <div>
                      <h4 className="card-title mb-1">Mağaza Favorileri</h4>
                      <p className="text-muted small mb-0">
                        Kullanıcıların favorilediği mağazalar. Toplam {liste.length} kayıt.
                      </p>
                    </div>
                    <Button color="primary" size="sm" onClick={fetchListe} disabled={isLoading}>
                      <i className="bx bx-refresh" /> Yenile
                    </Button>
                  </div>
                  {isLoading ? (
                    <div className="text-center py-5"><Spinner color="primary" /></div>
                  ) : (
                    <TableContainer
                      columns={columns}
                      data={liste}
                      isGlobalFilter={true}
                      isPagination={true}
                      customPageSize={15}
                      SearchPlaceholder="Ara..."
                      tableClass="align-middle table-nowrap table-hover"
                      theadClass="table-light"
                      paginationWrapper="dataTables_paginate paging_simple_numbers pagination-rounded"
                      pagination="pagination pagination-rounded justify-content-end mb-2"
                    />
                  )}
                </CardBody>
              </Card>
            </Col>
          </Row>
        </div>
      </div>
    </React.Fragment>
  );
};

export default MagazaFavorileri;
